export default __webpack_public_path__ + "static/media/show-carousel.eb03bdcf.svg";